export default {
  root: {
    width: '100%',
    marginTop: 16,
    marginBottom: 16,
  },
};
